import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { GeneralProvider } from './contexts/GeneralContext';
// ---- import components for ROUTING ----------------------------------------- //
import Home from './screens/home/Home';
import './App.css';

function App() {
  // state is the overall STATE object that has sub states and can be found in the index.js of the reducer folder
  const dispatch = useDispatch();
  const stateObj = useSelector((state) => state);
  return (
    <Router>
      <Switch>
        <GeneralProvider>
            <Route exact path='/' render={ (routeProps) => <Home {...routeProps} allStates = {stateObj} dispatch = {dispatch} /> } ></Route>
        </GeneralProvider>
      </Switch>
    </Router>
  );
}

export default App;
